import { createReducer, on } from '@ngrx/store';
import { getImpMail, setImpMail, saveImpMail, deleteImpMail } from '../actions/mailinfo.actions';

export interface ImpMailState {
  commonProperties: any;
}

export const initialState: ImpMailState = {
  commonProperties: {}
};
export const mailInfoReducer = createReducer(
  initialState,
  on(getImpMail, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(setImpMail, (state, { impMail }) => ({
    ...state,
    ...{ impMail }
  })),
  on(saveImpMail, (state, { impMailData }) => ({
    ...state,
    ...impMailData
  })),
  on(deleteImpMail, (state, { ids }) => ({
    ...state,
    ...ids
  }))
);
